import React, { Component } from 'react';

import { Alert, Card, CardBody } from 'reactstrap';
import { connect } from "react-redux";
import { SlPageTitle, MfaCodeEntry, SlYesNo, SlBusyIndicator, SlFormEntryRow, SlButton } from '../editors'

import Stepper from "./Stepper";
import { registrationActions } from "../../_actions";
import { registrationConstants } from '../../_constants';
import { history   } from "../../_helpers";

import  { metadataService, workflowService } from '../../_services'
import { workflowConstants } from '../../_constants/workflow.constants';
 class SignUpEmailValidation extends Component {
    static displayName = SignUpEmailValidation.name;

    constructor(props) {
        super(props);
        this.state = {
            formValue: {
                mfaCode : ['', ''],
                emailValidationToken: this.props.emailValidationToken
            },
            saveDevice: "true",
            confirmationCodeError: false,
            formError: false
        }

        this.handleMfaCodeUpdated = this.handleMfaCodeUpdated.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleReSendEmailCodeRequest = this.handleReSendEmailCodeRequest.bind(this);

    }
    componentDidMount() {
        if (!this.props.completedSteps.find(t => t === registrationConstants.SEND_EMAIL_CODE_REQUEST)){
            history.push("/SignUpCreatePassword")
        }
        if(this.props.completedSteps.find(t => t === registrationConstants.PROFILE_CREATE_REQUEST)){
            history.push("/SignUpOptInValidation")
          }
    }

     handleSubmit = () => {
         const { dispatch } = this.props;


        let confirmationCodeFirstPart = this.state.formValue.mfaCode[0]
        let confirmationCodeSecondPart = this.state.formValue.mfaCode[1]

        let emailvalidation = 
        {
            tokenId: this.props.emailValidationToken,
            confirmationCodeFirstPart: confirmationCodeFirstPart,
            confirmationCodeSecondPart: confirmationCodeSecondPart
        }
    
        let profile = {
            userId: this.props.email,
            dateOfBirth: this.props.dateOfBirth,
            nationalIdNumber: this.props.idNumber,
            userHash: this.props.userHash,
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            selectedLanguage: this.props.language,
            street1: this.props.address,
            street2: this.props.address2,
            city: this.props.city,
            state: this.props.userState,
            postalCode: this.props.zipCode,
            Email: this.props.email,
            Password: this.props.password,
            ConfirmPassword: this.props.confirmPassword,
            PhoneNumber: this.props.mobileNumber, 
            IsAdmin: false
        }


        dispatch(registrationActions.handleEmailValidationResponse(emailvalidation, profile, this.state.saveDevice === 'true'));
     }

     handleMfaCodeUpdated(newMfaCode) {
        // const newForm = {mfaCode : newMfaCode}
        // const newState = {formValue : newForm}
        this.setState({formValue : {mfaCode : newMfaCode}})
     }
     handleReSendEmailCodeRequest(){
      const {codeToEmail} = this.props;
      if(codeToEmail){
        this.props.actions.handleReSendEmailCodeRequest(codeToEmail);
      }
     }
     
     handleChange(e){
        this.setState({saveDevice:e.target.value})
     }
     handleBack(){
        this.props.actions.handleSignUpEmailValidationBackRequest();
     }
     render() {
         const { email, isBusy } = this.props;

         let currentStepData = workflowService.getCurrentWorkflowStepData();
         let currentWorkflowId = currentStepData ? currentStepData.workflowId : null;

         let sentMessage = "";
         let pageName = "";

         if (currentWorkflowId === workflowConstants.EXISTING_CUSTOMER_REGISTRATION_WORKFLOW || currentWorkflowId === workflowConstants.GUEST_PAYMENT_REGISTRATION) {
             sentMessage = metadataService.getMessage("ExistingEmailValidation");
             pageName = "AccountConfirmation";
         } else {
             sentMessage = metadataService.getTitle("EmailValidation") + ' ' + email;
             pageName = "EmailConfirmation";
         }

        return (
            <div className="SignUpEmailValidation">
                
                {this.props.steps.length > 0 && (
                    <Stepper stepData={this.props.steps} currentStep={this.props.currentStep} />
                )}

                <SlPageTitle pageName={pageName} />                
                {!this.props.isBusy && (
                    <React.Fragment>
                        <MfaCodeEntry
                            mfaSentMessage={sentMessage}
                            value={this.state.formValue.mfaCode}
                            valueUpdated={this.handleMfaCodeUpdated}
                            onSubmit={this.handleSubmit}
                            disabled={isBusy}
                            onReSend={this.handleReSendEmailCodeRequest}
                            />
                        <Card>
                            <CardBody className="justify-content-center">
                                <SlFormEntryRow>
                                <SlYesNo name="saveDevice"  onChange={this.handleChange} labelName='RememberDevice'
                                value={this.state.saveDevice}
                                trueValue='true' falseValue='false' trueText={metadataService.getLabel("Yes")} 
                                falseText={metadataService.getLabel("No")}
                                labelCssClass="text-left"/>
                                </SlFormEntryRow>   
                            </CardBody>
                        </Card>                         
                        {this.props.error && (
                            <Card>
                            <CardBody className="justify-content-center">
                                <SlFormEntryRow>                                    
                                    <Alert className="ml-0 mr-0" color='danger'>{this.props.errorString}</Alert>
                                </SlFormEntryRow>   
                            </CardBody>
                        </Card>                                            
                        )}
                     {this.props.steps.length > 0 && (
                          <Card>
                            <CardBody className="justify-content-center text-center">
                                    <SlButton name='Back' onClick={this.handleBack} />                                   
                            </CardBody>
                         </Card>                              
                        )}
                </React.Fragment>
                )}
                {this.props.isBusy && (
                    <SlBusyIndicator visible={this.props.isBusy}/>
                )}
            </div>
        );
    }
}


function mapStateToProps(state) {
  const { loggedIn } = state.authentication;
  const {
    existingCustomer,
    error,
    email,
    emailValidationToken,
    firstName,
    lastName,
    confirmEmail,
    mobileNumber,
    address,
    address2,
    city,
    userState,
    zipCode,
    language,
    dateOfBirth,
    idNumber,
    isIDConsular,
    isIDSSN,
    userHash,
    password,
    confirmPassword,
    errorString,
    isBusy,
    completedSteps,
    codeToEmail,
  } = state.registration;
  const { steps, currentStep } = state.users;

  return {
    loggedIn,
    existingCustomer,
    error,
    email,
    emailValidationToken,
    firstName,
    lastName,
    confirmEmail,
    mobileNumber,
    address,
    address2,
    city,
    userState,
    zipCode,
    language,
    dateOfBirth,
    idNumber,
    isIDConsular,
    isIDSSN,
    userHash,
    password,
    confirmPassword,
    errorString,
    isBusy,
    completedSteps,
    steps,
    currentStep,
    codeToEmail,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    actions: {
      handleReSendEmailCodeRequest: (codeToEmail) => {
        dispatch(registrationActions.handleReSendEmailCodeRequest(codeToEmail));
      },
      handleSignUpEmailValidationBackRequest: () => {
        dispatch(registrationActions.handleSignUpEmailValidationBackRequest());
      },
    },
  };
};

const connectedSignUpEmailValidation = connect(mapStateToProps,mapDispatchToProps)(SignUpEmailValidation);
export { connectedSignUpEmailValidation as SignUpEmailValidation };